/**
 * Japanese messages for the streamer studio (Japanese-only screens) about moderation state.
 */
import type { ImageSubmissionStatus, MyModerationStatus } from './types';

type ApiErrorShape = { code?: string; params?: Record<string, unknown>; message?: string };

const STREAMER_FIELD_LABELS: Record<string, string> = {
  display_name: '表示名',
  bio: '自己紹介',
  hobbies: '趣味',
  favorite_food: '好きな食べ物',
  features: '特徴',
  genre: 'ジャンル',
  region: '地域',
  occupation: '職業',
  personality: '性格',
};

export type ProfileImageReviewState = Extract<ImageSubmissionStatus, 'pending' | 'rejected'> | null;

export function profileImageReviewState(status: MyModerationStatus | null): ProfileImageReviewState {
  const submission = status?.profile_image_submission;
  if (submission?.status === 'pending' || submission?.status === 'rejected') return submission.status;
  return null;
}

export const PROFILE_IMAGE_REVIEW_MESSAGES: Record<Exclude<ProfileImageReviewState, null>, string> = {
  pending: '新しいプロフィール画像は運営の確認後に公開されます（承認待ち）',
  rejected: '前回アップロードした画像は承認されませんでした。別の画像をアップロードしてください',
};

/** Message for a failed profile save; NG word rejections name the field and the words. */
export function profileSaveErrorMessage(error: unknown): string {
  const apiError = (typeof error === 'object' && error !== null ? error : {}) as ApiErrorShape;
  if (apiError.code === 'NG_WORD_DETECTED') {
    const field = typeof apiError.params?.field === 'string' ? STREAMER_FIELD_LABELS[apiError.params.field] ?? '入力内容' : '入力内容';
    const words = typeof apiError.params?.words === 'string' ? `（${apiError.params.words}）` : '';
    return `「${field}」に使用できない語句が含まれています${words}。表現を変えてください。`;
  }
  return apiError.message ? `プロフィールの保存に失敗しました: ${apiError.message}` : 'プロフィールの保存に失敗しました';
}
